// Native autofocus is unreliable when Vue inserts an input after navigation.
// Focus once on mount so typing and later updates keep the user's selection.
export const focus = {
    mounted(el) {
        el.focus({ preventScroll: true })
    }
}
